<template>
  <div>
    test
  </div>
</template>

<script>
export default {
  components: {
  },
  data: () => ({
    
  }),
  computed: {
    enterpriseID () {      
      return this.$store.state.app.enterpriseID
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
